import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'}) //Makes User service available globally
export class User {
    userId?: number;
    accountOwnerId?: number;
    sellerId?: number;
    adminUserId?: number;
    accountOwnerName? :string;
    userName? :string;
    loadedSampleData? :string;
    mobileNumber? :string;
    organizationId: number = 1;
    role: any;
    token?: string;
    logoURl?: string;
    driverId?: number;
    orgUserId?: number;
    duration?: number;
}

